import React, { createContext, useContext, useState, useEffect } from "react";
import logo from "../assets/media/livensa/Studios-livensaliving.png";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { API_URLS } from "../api/apiConfig";
import { postWithAuth, postWithoutAuth } from "../api/api";

const LoginChangePassword = () => {
  const { session } = useParams(); // Captura el parámetro 'session' de la URL
  const [showAlert, setIshowAlert] = useState(false);
  const [alertMessage, setShowAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState({
    email: "",
    password: "",
    session: session || "",
  });

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;

    setNewPassword((prevPassword) => {
      const newPassword = {
        ...prevPassword,
        [name]: type === "checkbox" ? !prevPassword[name] : value,
      };

      return newPassword;
    });
  };

  const saveMap = async (e) => {
    const formData = new FormData();
    formData.append("data", JSON.stringify(newPassword));
    try {
      setIsLoading(true);
      const response = await postWithoutAuth(
        API_URLS.FORCE_CHANGE_PASSWORD,
        newPassword
      );
      console.log("FormData", formData);
      if (response.message === "success") {
        setIsLoading(false);
        navigate("/login");
        window.location.reload();
      } else if (response.message === "error") {
        setIsLoading(false);
        setIshowAlert(true);
        setShowAlertMessage(response.detail);
      } else {
        //setAlertType('danger');
        //setMessage("Error inesperado");
        //setShowAlertHeader(true);
      }
    } catch (error) {
      console.error("Error creating user admin:", error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      saveMap();
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-lg-row-fluid w-lg-50 bg-azul-color-azul-livensa">
          <div className="d-flex flex-column flex-center p-6 p-lg-10 w-100">
            <a
              href="#"
              className="mb-0 mb-lg-20"
              onClick={(e) => e.preventDefault()}
            >
              <img alt="Logo" src={logo} className="h-40px h-lg-50px" />
            </a>
            <img
              className="d-none d-lg-block mx-auto w-300px w-lg-75 w-xl-500px mb-10 mb-lg-20"
              src="/media/misc/auth-screens.png"
              alt=""
            />
            <h1 className="d-none d-lg-block text-white fs-2qx fw-bold text-center mb-7">
              Rápido, eficiente y productivo
            </h1>
            <div className="d-none d-lg-block text-white fs-base text-center">
              Gestiona de manera{" "}
              <a className="opacity-75-hover text-warning fw-semibold me-1">
                inteligente
              </a>
              las habitaciones
              <br /> de tus alojamientos con una interfaz
              <a className="opacity-75-hover text-warning fw-semibold me-1">
                {" "}
                rápida
              </a>
              que mejora en gran medida tu <br />
              <a className="opacity-75-hover text-warning fw-semibold me-1">
                productividad
              </a>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10">
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            <div className="w-lg-500px p-10">
              <form className="form w-100">
                <div className="text-center mb-11">
                  <h1 className="text-gray-900 fw-bolder mb-3">
                    Iniciar sesión
                  </h1>
                </div>

                {showAlert && (
                  <div className="alert alert-danger d-flex align-items-center p-5">
                    <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>

                    <div className="d-flex flex-column">
                      <span className="mb-1 text-danger">
                        Usuario o contraseña incorrecta
                      </span>
                    </div>
                  </div>
                )}

                <div className="fv-row mb-8">
                  <input
                    type="text"
                    className="form-control form-control-solid"
                    placeholder="Email"
                    name="email"
                    onChange={handleInputChange}
                    defaultValue={""}
                  />
                </div>

                <div className="fv-row mb-3">
                  <input
                    type="password"
                    className="form-control form-control-solid"
                    placeholder="Contraseña"
                    name="password"
                    onChange={handleInputChange}
                    defaultValue={""}
                  />
                </div>

                {/*
                                    <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                                        <div></div>
                                        <a href="" className="link-primary">
                                            Contraseña olvidada
                                        </a>
                                    </div>
                                    */}

                <div className="d-grid mb-10">
                  <button
                    type="submit"
                    onClick={handleSave}
                    className="btn btn-primary"
                    data-kt-indicator={`${isLoading ? "on" : "off"}`}
                  >
                    <span className="indicator-label">Cambiar contraseña</span>
                    <span className="indicator-progress">
                      Autenticando...{" "}
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginChangePassword;
